// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export interface LocalStorageStateProps {
  pollingEnabled?: boolean;
  webSocketEnabled?: boolean;
  activeContractsLogsEnabled?: boolean;
  isDark?: boolean;
}

export interface LocalStorageContextProps {
  localStorageState: LocalStorageStateProps;
  setLocalStorageState: (key: string, val: string) => void;
}

export const LocalStorageContext = React.createContext({} as LocalStorageContextProps);

export const useLocalStorage = () => {
  return React.useContext(LocalStorageContext);
};
